import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — Scrolls to top of page on every route change.
 * Place inside BrowserRouter, before Routes.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
